// External Dependencies:
import React from 'react'

// Internal Dependencies:
import { easings } from 'utilities/easings'

class PageEventsTransition extends React.Component {
	constructor( props ) {
		super( props )

		this.ref = React.createRef()

		this.path = null
		// this.numPoints = 10
		this.numPoints = 4
		this.duration = 700
		this.delayPointsArray = []
		this.delayPointsMax = 300
		this.delayPerPath = 250
		this.timeStart = Date.now()
		this.isOpened = false
		this.isAnimating = false
	}

	componentDidMount() {
		this._isMounted = true
		this.path = this.ref.current.querySelectorAll( 'path' )
		this.run( 'bottomToTop' )

		window.addEventListener( 'doPageTransition', () => {
			this.run( 'topToBottom' )
		}, false )

		window.addEventListener( 'doPageTransitionLeftToRight', () => {
			this.run( 'leftToRight' )
		}, false )

		window.addEventListener( 'doPageTransitionRightToLeft', () => {
			this.run( 'rightToLeft' )
		}, false )
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( ! this.props.match ) {
			return
		}

		const { dispatch, match, type, history } = this.props
		const { params, path } = match

		const isAppended = this.props.pageOverride ? true : false
		const prevParams = prevProps.match.params
		const prevPath = prevProps.match.path
		const archivePageNumber = params.archivePageNumber ? params.archivePageNumber : false
		const prevArchivePageNumber = prevParams.archivePageNumber ? prevParams.archivePageNumber : false

		if ( '/' == path && '/' != prevProps.match.path ) {
			this.run( 'topToBottom' )
		} else if (
			! isAppended &&
			( type != prevProps.type || params.slug != prevParams.slug )
		) {
			// // Fade content:
			// document.documentElement.classList.add( 'has-transition-page-leaving' )

			// setTimeout( () => {
			// 	document.documentElement.classList.remove( 'has-transition-page-leaving' )
			// }, 400 )

			// Run animation:
			if ( 'POP' == history.action ) {
				// // Fade content:
				// document.documentElement.classList.add( 'has-transition-page-hidden' )
				// document.documentElement.classList.add( 'has-transition-page-leaving' )

				// setTimeout( () => {
				// 	document.documentElement.classList.remove( 'has-transition-page-hidden' )
				// 	document.documentElement.classList.remove( 'has-transition-page-leaving' )
				// }, 400 )

				this.run( 'bottomToTop' )
			} else {
				// this.run( 'topToBottom' )
			}
		}
	}

	run = ( type = 'topToBottom' ) => {
		if ( this.isAnimating ) {
			return
		}

		this.isAnimating = true

		for ( var i = 0; i < this.numPoints; i++ ) {
			this.delayPointsArray[ i ] = Math.random() * this.delayPointsMax
		}

		// this.close()
		// this.open()
		// this.runTopToBottom()

		if ( 'topToBottom' == type ) {
			this.runTopToBottom()
		} else if ( 'bottomToTop' == type ) {
			this.runBottomToTop()
		} else if ( 'leftToRight' == type ) {
			this.runLeftToRight()
		} else if ( 'rightToLeft' == type ) {
			this.runRightToLeft()
		}

		setTimeout( () => {
			this.isOpened = false
			this.ref.current.classList.add( 'is-finished-animating' )
			this.ref.current.classList.remove( 'is-animating' )
		}, this.duration + 400 )
	}

	runTopToBottom = () => {
		this.topToBottom = true
		this.bottomToTop = false
		this.leftToRight = false
		this.rightToLeft = false

		this.runStart()
	}

	runBottomToTop = () => {
		this.topToBottom = false
		this.bottomToTop = true
		this.leftToRight = false
		this.rightToLeft = false

		this.runStart()
	}

	runLeftToRight = () => {
		this.topToBottom = false
		this.bottomToTop = false
		this.leftToRight = true
		this.rightToLeft = false

		this.runStart()
	}

	runRightToLeft = () => {
		this.topToBottom = false
		this.bottomToTop = false
		this.leftToRight = false
		this.rightToLeft = true

		this.runStart()
	}

	runStart = () => {
		this.ref.current.classList.add( 'is-animating' )
		this.ref.current.classList.remove( 'is-finished-animating' )
		this.timeStart = Date.now()
		this.runLoop()
	}

	// toggle = () => {
	// 	this.isAnimating = true

	// 	for ( var i = 0; i < this.numPoints; i++ ) {
	// 		this.delayPointsArray[ i ] = Math.random() * this.delayPointsMax
	// 	}

	// 	if ( this.isOpened === false ) {
	// 		this.open()
	// 	} else {
	// 		this.close()
	// 	}
	// }

	// open = () => {
	// 	this.isOpened = true
	// 	this.bottomToTop = false
	// 	this.topToBottom = true
	// 	this.ref.current.classList.add( 'is-animating' )
	// 	this.ref.current.classList.remove( 'is-finished-animating' )
	// 	this.timeStart = Date.now()
	// 	this.runLoop()
	// }

	// close = () => {
	// 	this.isOpened = false
	// 	this.bottomToTop = true
	// 	this.topToBottom = false
	// 	this.ref.current.classList.remove( 'is-animating' )
	// 	this.timeStart = Date.now()
	// 	this.runLoop()
	// }

	updatePath = ( time ) => {
		const points = []

		for ( var i = 0; i < this.numPoints; i++ ) {
			if ( this.bottomToTop ) {
				points[ i ] = (
					1 - easings.cubicInOut(
						Math.min( Math.max( time - this.delayPointsArray[ i ], 0 ) / this.duration, 1 )
					)
				) * 100
			} else if ( this.leftToRight ) {
				points[ i ] = easings.cubicInOut(
					Math.min( Math.max( time - this.delayPointsArray[ i ], 0 ) / this.duration, 1 )
				) * 100
			} else if ( this.rightToLeft ) {
				points[ i ] = (
					1 - easings.cubicInOut(
						Math.min( Math.max( time - this.delayPointsArray[ i ], 0 ) / this.duration, 1 )
					)
				) * 100
			} else {
				// topToBottom:

				points[ i ] = easings.cubicInOut(
					Math.min( Math.max( time - this.delayPointsArray[ i ], 0 ) / this.duration, 1 )
				) * 100
			}
		}

		let str = ''
		// str += ( this.isOpened ) ? `M 0 0 V ${points[0]}` : `M 0 ${points[0]}`

		if ( this.bottomToTop ) {
			str += `M 0 ${points[0]}`
		} else if ( this.leftToRight ) {
			str += `M ${points[0]} 0`
		} else if ( this.rightToLeft ) {
			str += `M ${points[0]} 0`
		} else {
			// topToBottom:

			str += `M 0 ${points[0]}`
		}

		for ( var i = 0; i < this.numPoints - 1; i++ ) {
			const p = ( i + 1 ) / ( this.numPoints - 1 ) * 100
			const cp = p - ( 1 / ( this.numPoints - 1 ) * 100 ) / 2
			// str += `C ${cp} ${points[ i ]} ${cp} ${points[ i + 1 ]} ${p} ${points[ i + 1 ]} `

			if ( this.bottomToTop ) {
				str += `C ${cp} ${points[ i ]} ${cp} ${points[ i + 1 ]} ${p} ${points[ i + 1 ]} `
			} else if ( this.leftToRight ) {
				str += `C ${points[ i ]} ${cp} ${points[ i + 1 ]} ${cp} ${points[ i + 1 ]} ${p} `
			} else if ( this.rightToLeft ) {
				str += `C ${points[ i ]} ${cp} ${points[ i + 1 ]} ${cp} ${points[ i + 1 ]} ${p} `
			} else {
				// topToBottom:

				str += `C ${cp} ${points[ i ]} ${cp} ${points[ i + 1 ]} ${p} ${points[ i + 1 ]} `
			}
		}

		if ( this.bottomToTop ) {
			// str += ( this.isOpened ) ? `V 100 H 0` : `V 0 H 0`
			str += 'V 100 H 0'
		} else if ( this.leftToRight ) {
			str += 'H 0 V 0'
		} else if ( this.rightToLeft ) {
			str += 'H 100 V 0'
		} else {
			// topToBottom:

			// str += ( this.isOpened ) ? `V 0 H 0` : `V 100 H 0`;
			str += 'V 0 H 0'
		}

		return str
	}

	runFrame = () => {
		for ( var i = 0; i < this.path.length; i++ ) {
			this.path[ i ].setAttribute( 'd', this.updatePath( Date.now() - ( this.timeStart + this.delayPerPath * i ) ) )
		}

		// if ( this.bottomToTop ) {
		// 	for ( var i = 0; i < this.path.length; i++ ) {
		// 		this.path[ i ].setAttribute( 'd', this.updatePath( Date.now() - ( this.timeStart + this.delayPerPath * i ) ) )
		// 	}
		// } else {
		// 	for ( var i = 0; i < this.path.length; i++ ) {
		// 		this.path[ i ].setAttribute( 'd', this.updatePath( Date.now() - ( this.timeStart + this.delayPerPath * i ) ) )
		// 	}
		// }

		// if ( this.isOpened ) {
		// 	for ( var i = 0; i < this.path.length; i++ ) {
		// 		this.path[ i ].setAttribute( 'd', this.updatePath( Date.now() - ( this.timeStart + this.delayPerPath * i ) ) )
		// 	}
		// } else {
		// 	for ( var i = 0; i < this.path.length; i++ ) {
		// 		this.path[ i ].setAttribute( 'd', this.updatePath( Date.now() - ( this.timeStart + this.delayPerPath * ( this.path.length - i - 1 ) ) ) )
		// 	}
		// }
	}

	runLoop = () => {
		this.runFrame()

		if ( Date.now() - this.timeStart < this.duration + this.delayPerPath * ( this.path.length - 1 ) + this.delayPointsMax ) {
			requestAnimationFrame( () => {
				this.runLoop()
			} )
		} else {
			this.isAnimating = false
		}
	}

	render() {
		return (
			<div className="page-transition-waves" ref={ this.ref }>
				<svg preserveAspectRatio="none" viewBox="0 0 100 100">
					<defs>
						<linearGradient id="page-transition-gradient" x1="0%" x2="0%" y1="0%" y2="100%">
							<stop className="page-transition-waves-color-stop-1" offset="0%" stopColor="#FF9502"></stop>
							<stop className="page-transition-waves-color-stop-2" offset="100%" stopColor="#FDC037"></stop>
						</linearGradient>
						<linearGradient id="page-transition-gradient-website" x1="0%" x2="0%" y1="0%" y2="100%">
							<stop offset="0%" stopColor="#FF9502"></stop>
							<stop offset="100%" stopColor="#FDC037"></stop>
						</linearGradient>
						<linearGradient id="page-transition-gradient-branding" x1="0%" x2="0%" y1="0%" y2="100%">
							<stop offset="0%" stopColor="#B59FDA"></stop>
							<stop offset="100%" stopColor="#ACBDF4"></stop>
						</linearGradient>
						<linearGradient id="page-transition-gradient-graphic_design" x1="0%" x2="0%" y1="0%" y2="100%">
							<stop offset="0%" stopColor="#A5DA9A"></stop>
							<stop offset="100%" stopColor="#96E1C7"></stop>
						</linearGradient>
					</defs>

					<path></path>
					<path></path>
					<path></path>
				</svg>
			</div>
		)
	}
}

export default PageEventsTransition



// WEBPACK FOOTER //
// ./containers/PageEventsTransition.jsx